import { Injectable } from "@angular/core"

import { AppEnv } from "../app/app.env"

/**
 * Objeto para manipulação do Local Storage
 */
@Injectable()
export class AppLocalStorage {

  static hasLocalStorage() {

    return (typeof(Storage) !== "undefined")
  }

  static check() {

    let appName = AppEnv.name
    let hasLocalStorage = AppLocalStorage.hasLocalStorage()

    if (hasLocalStorage && !localStorage[appName])
      localStorage[appName] = "{}"

    return hasLocalStorage
  }

  static set(prop, value) {

    if (!AppLocalStorage.check())
      return

    let appName = AppEnv.name
    let app = JSON.parse(localStorage[appName])

    app[prop] = value

    localStorage[appName] = JSON.stringify(app)
  }

  static get(prop) {

    if (!AppLocalStorage.check())
      return

    let appName = AppEnv.name
    let app = JSON.parse(localStorage[appName])

    return app[prop]
  }

}



// WEBPACK FOOTER //
// ./src/services/app-local-storage.ts